export const healthPackagesData = [
  {
    id: "executive-health",
    name: "Surya Vital Health Package",
    icon: "Briefcase",
    description: "Comprehensive health screening for busy professionals",
    image: process.env.PUBLIC_URL + "/images/svhp.png",
    details: "A comprehensive health screening package that includes blood tests, organ function profiles, and diagnostic imaging to assess overall wellness. It evaluates key systems such as liver, kidney, heart, blood components, metabolism, and bone health, helping detect early signs of disease and providing a complete picture of your current health status.",
    tiers: [
      {
        name: "Main",
        price: "₹7,999",
        tests: [
          "CBC (20)",
  "Blood Sugar (Random)",
  "Liver Profile (8)",
  "SGPT / SGOT / Alkaline Phosphate",
  "Bilirubin (Total / Direct / Indirect)",
  "Total Proteins / Albumin / Globulin",
  "Lipid Profile (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "Kidney Profile (3)",
  "BUN / BUL / Uric Acid / Creatinine",
  "ECG",
  "BMD",
  "X-Ray Chest",
  "USG Abdomen Pelvis",
  "Liver Elastography",
  "2D Echo GLS"
        ]
      },
   
    ]
  },
  {
    id: "preventive-packages",
    name: "Preventive Packages",
    icon: "HeartPulse",
    description: "Comprehensive preventive health packages designed to detect early signs of illness and support long-term wellness through essential tests and screenings.",
    image: "https://media.istockphoto.com/id/1388227372/photo/woman-doctor-holding-heart-in-hands.jpg?s=612x612&w=0&k=20&c=DBJ9pJuS46S2jMBEEn1Um7WF6icySIEuV-d8jCAqqxQ=",
    details: "Our Preventive Health Packages offer a complete evaluation of your overall well-being, covering infection markers, liver and kidney function, diabetes screening, thyroid health, and bone strength. The package also includes important diagnostic screenings such as X-Ray, USG Abdomen & Pelvis, and cardiac evaluation. Ideal for individuals experiencing symptoms like fatigue, bone pain, weakness, or abdominal discomfort, these packages help in early detection and timely medical guidance for a healthier life.",
    tiers: [
      {
        name: "Preventive Silver",
        price: "₹1,999",
        tests: [
           "PathologyTest",
  "CBC (20)",
  "Blood Group",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest"
        ]
      },
      {
        name: "Preventive Gold",
        price: "₹3,899",
        tests: [
           "PATHOLOGY TEST",
  "CBC (20)",
  "Blood Group",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "SPECIALIZED INVESTIGATIONS",
  "Serum Electrolytes (Na+K+Cl)",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis"
        ]
      },
      {
        name: "Preventive Platinum",
        price: "₹5,072",
        tests: [
          "PATHOLOGY TEST",
  "CBC (20)",
  "Blood Group",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "SPECIALIZED INVESTIGATIONS",
  "TFT (Thyroid Function Test) - T3, T4, TSH",
  "Serum Electrolytes (Na+K+Cl)",
  "Vitamin B12",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis"
        ]
      },
      {
        name: "Preventive Diamond",
        price: "₹7,019",
        tests: [
          "PATHOLOGY TEST",
  "CBC (20)",
  "Blood Group",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "SPECIALIZED INVESTIGATIONS",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "Serum Electrolytes (Na+K+Cl)",
  "Vitamin B12",
  "Vitamin D3",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis",
  "BMD"
        ]
      }
    ]
  },
  {
    id: "cardiac-health",
    name: "Cardiac Health Package",
    icon: "HeartPulse",
    description: "Comprehensive cardiac health packages designed to assess heart function, detect early risk factors, and support timely prevention of heart diseases.",
    image: "https://media.istockphoto.com/id/1335296825/photo/cropped-close-up-smiling-woman-holding-folded-hands-on-chest.jpg?s=612x612&w=0&k=20&c=w5KPxziodxFuqXCWdlJ45u56f_bSZW6rvietewUJ0cQ=",
    details: "Our Cardiac Health Packages offer an in-depth evaluation of your heart and overall health through essential laboratory tests and advanced cardiac screenings. These packages include assessments for cardiac function, infection markers, liver and kidney conditions, and thyroid health. Diagnostic screenings such as 2D Echo Cardiography, ECG, and TMT (Stress Test) provide a complete understanding of heart performance. Ideal for individuals with a family history of heart disease or those experiencing symptoms like fluctuating blood pressure, chest pain, dizziness, nausea, or headaches, these packages enable early detection and better management of heart-related conditions.",
    tiers: [
      {
        name: "Cardiac Silver",
        price: "₹2,850",
        tests: [
           "PathologyTest",
  "CBC (20)",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "DIAGNOSTIC TESTS",
  "ECG",
  "2D Echo"
        ]
      },
      {
        name: "Cardiac Gold",
        price: "₹4,750",
        tests: [
           "PATHOLOGY TEST",
  "CBC (20)",
  "ESR",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "DIAGNOSTIC TESTS",
  "ECG",
  "2D Echo"
        ]
      },
      {
        name: "Cardiac Platinum",
        price: "₹6,950",
        tests: [
         "PATHOLOGY TEST",
  "CBC (20)",
  "ESR",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "DIAGNOSTIC TESTS",
  "ECG",
  "Stress Test (TMT)",
  "2D Echo"
        ]
      },
      {
        name: "Cardiac Diamond",
        price: "₹9,550",
        tests: [
           "PATHOLOGY TEST",
  "CBC (20)",
  "ESR",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "Homocysteine",
  "HS-CRP",
  "LP (a)",
  "DIAGNOSTIC TESTS",
  "ECG",
  "Stress Test (TMT)",
  "2D Echo"
        ]
      }
    ]
  },
  {
    id: "diabetes-screening",
    name: "Diabetes Package",
    icon: "Activity",
    description: "Comprehensive diabetic health packages designed to detect, monitor, and manage diabetes-related complications through advanced lab tests and essential diagnostic screenings.",
    image: "https://images.pexels.com/photos/4033023/pexels-photo-4033023.jpeg",
    details: "Our Diabetic Health Packages provide a complete evaluation of diabetes and its associated health risks. These packages include laboratory tests for diabetes mellitus, thyroid function, kidney health, liver profile, infection markers, and fluid balance. To ensure thorough assessment, key diagnostic screenings such as Carotid Doppler, USG Abdomen & Pelvis, X-Ray Chest, and ECG are also included, along with physician consultation for detailed guidance. Ideal for individuals experiencing symptoms like frequent urination, excessive thirst, fatigue, unexplained weight loss, increased hunger, or dry skin, these packages help in early detection, effective monitoring, and better management of diabetes to prevent long-term complications.",
    tiers: [
      {
        name: "Diabetic Silver",
        price: "₹3,300",
        tests: [
           "PATHOLOGY TEST",
  "CBC (20)",
  "ESR",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Calcium",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis"
        ]
      },
      {
        name: "Diabetic Gold",
        price: "₹4,400",
        tests: [
        "PATHOLOGY TEST",
  "CBC (20)",
  "ESR",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Calcium",
  "Serum Electrolytes (Na+K+Cl-)",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "SPECIALIZED INVESTIGATIONS",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis"
        ]
      },
      {
        name: "Diabetic Platinum",
        price: "₹6,280",
        tests: [
          "PATHOLOGY TEST",
  "CBC (20)",
  "ESR",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "Insulin Fasting & PP",
  "Urine Micro-Albumin",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Calcium",
  "Serum Electrolytes (Na+K+Cl-)",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis"
        ]
      },
      {
        name: "Diabetic Diamond",
        price: "₹10,200",
        tests: [
        "PATHOLOGY TEST",
  "CBC (20)",
  "ESR",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "C-peptide",
  "Insulin Fasting & PP",
  "Urine Micro-Albumin",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Calcium",
  "Serum Electrolytes (Na+K+Cl-)",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis",
  "Carotid Doppler",
  "Physician Consultation"
        ]
      }
    ]
  },
  {
    id: "women-health",
    name: "Women's Health Package",
    icon: "User",
    description: "Comprehensive women’s wellness packages designed for early detection and prevention of health issues, ensuring overall well-being through essential tests and screenings.",
    image: "https://images.pexels.com/photos/3259624/pexels-photo-3259624.jpeg",
    details: "The Wellness Women’s Health Package at Surya Diagnostics Center provides a complete assessment of women’s health through a wide range of laboratory tests and diagnostic screenings. It includes tests for infection markers, liver and kidney function, diabetes, thyroid function, hormone levels, bone health, and fluid balance. Advanced screenings such as CT Scan of the Brain, USG Abdomen & Pelvis, Sonomammography, X-Ray Chest, BMD, and ECG are also included. This package is ideal for women experiencing symptoms like painful or burning urination, breast pain, vulvar redness or swelling, abnormal vaginal discharge, nausea, vomiting, or abdominal tenderness. Early detection through these tests allows timely medical intervention, helping maintain good health and prevent serious complications.",
    tiers: [
      {
        name: "Silver",
        price: "₹4,399",
        tests: [
         "PATHOLOGY TEST",
  "CBC (20)",
  "Blood Group",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Serum Electrolytes (Na+K+Cl-)",
  "HORMONES LEVEL",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis"
        ]
      },
      {
        name: "Gold",
        price: "₹7,799",
        tests: [
          "PATHOLOGY TEST",
  "CBC (20)",
  "Blood Group",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Serum Electrolytes (Na+K+Cl-)",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "HORMONES LEVEL",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis",
  "Sonomammography"
        ]
      },
      {
        name: "Platinum",
        price: "₹9,879",
        tests: [
           "PATHOLOGY TEST",
  "CBC (20)",
  "Blood Group",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Serum Electrolytes (Na+K+Cl-)",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "HORMONES LEVEL",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "Prolactin",
  "FSH",
  "LH",
  "Testosterone",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis",
  "Sonomammography"
        ]
      },
      {
        name: "Diamond",
        price: "₹13,519",
        tests: [
         "PATHOLOGY TEST",
  "CBC (20)",
  "Blood Group",
  "Urine Routine (22)",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8)",
  "SGPT/SGOT/Alkaline Phosphate",
  "Bilirubin/Total Direct-Indirect",
  "Total Proteins/Albumin/Globulin",
  "LIPID PROFILE (7)",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3)",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Serum Electrolytes (Na+K+Cl-)",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "HORMONES LEVEL",
  "TFT (Thyroid Function Test) T3, T4, TSH",
  "Prolactin",
  "FSH",
  "LH",
  "Testosterone",
  "DIAGNOSTIC TESTS",
  "ECG",
  "BMD",
  "X Ray Chest",
  "USG Abdomen Pelvis",
  "Sonomammography",
  "CT Brain"
        ]
      }
    ]
  },
  {
    id: "mens-health",
    name: "Wellness Mens Package",
    icon: "UserCheck",
    description: "The Wellness Men’s Health Package at Surya Diagnostics Center offers a complete health evaluation for men, covering liver, diabetes, thyroid, kidney, bone health, and infection markers. It also includes major screenings like CT Chest & Brain, USG Abdomen Pelvis, X-Ray Chest & Spine, BMD, and ECG for early detection and better health management.",
    image: "https://media.istockphoto.com/id/2224635536/photo/father-talking-with-kids-in-the-kitchen.jpg?s=612x612&w=0&k=20&c=HA3w9YBilNK8SyEQACd0fJ6HPmuEQiTTNs7t6YqLLK0=",
    details: "Men often ignore early signs of illness due to a busy lifestyle. The Wellness Men’s Health Package provides a thorough assessment of key health parameters— including liver function, diabetes, thyroid, kidney health, bone strength, and infection markers. Along with lab tests, it includes CT Chest & Brain, USG Abdomen Pelvis, X-Ray Chest & Spine, BMD, and ECG to give a clear picture of overall health. If you experience symptoms like burning urination, fever, nausea, difficulty urinating, muscle aches, or digestive issues, this package helps in early detection and timely treatment.",
    tiers: [
      {
        name: "Silver",
        price: "₹4,399",
        tests: [
          "PATHOLOGY TEST",
  "CBC(20)",
  "Blood Group",
  "Urine Routine (22 )",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8 )",
  "SGPT/SGOT/ALKALINE PHOSPHATE",
  "BILIRUBIN/TOTAL DIRECT-INDIRECT",
  "TOTAL PROTEINS/ALBUMIN/GLOBULIN",
  "LIPID PROFILE ( 7 )",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3 )",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Serum Electrolytes (Na+k+Cl-)",
  "TFT (Thyroid function Test)T3,T4,TSH",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis"
        ]
      },
      {
        name: "Gold",
        price: "₹6,199",
        tests: [
            "PATHOLOGY TEST",
  "CBC(20)",
  "Blood Group",
  "Urine Routine (22 )",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8 )",
  "SGPT/SGOT/ALKALINE PHOSPHATE",
  "BILIRUBIN/TOTAL DIRECT-INDIRECT",
  "TOTAL PROTEINS/ALBUMIN/GLOBULIN",
  "LIPID PROFILE ( 7 )",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3 )",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Serum Electrolytes (Na+k+Cl-)",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "TFT (Thyroid function Test)T3,T4,TSH",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis"
        ]
      },
      {
        name: "Platinum",
        price: "₹9,799",
        tests: [
         "PATHOLOGY TEST",
  "CBC(20)",
  "Blood Group",
  "Urine Routine (22 )",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8 )",
  "SGPT/SGOT/ALKALINE PHOSPHATE",
  "BILIRUBIN/TOTAL DIRECT-INDIRECT",
  "TOTAL PROTEINS/ALBUMIN/GLOBULIN",
  "LIPID PROFILE ( 7 )",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3 )",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Serum Electrolytes (Na+k+Cl-)",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "TFT (Thyroid function Test)T3,T4,TSH",
  "PSA(PROSTATE)",
  "DIAGNOSTIC TESTS",
  "ECG",
  "X Ray Chest",
  "USG Abdomen Pelvis",
  "CT Brain"
        ]
      },
      {
        name: "Diamond",
        price: "₹14,830",
        tests: [
          "PATHOLOGY TEST",
  "CBC(20)",
  "Blood Group",
  "Urine Routine (22 )",
  "TEST FOR DIABETICS",
  "Blood Sugar (Fasting & PP)",
  "HbA1c",
  "LIVER PROFILE (8 )",
  "SGPT/SGOT/ALKALINE PHOSPHATE",
  "BILIRUBIN/TOTAL DIRECT-INDIRECT",
  "TOTAL PROTEINS/ALBUMIN/GLOBULIN",
  "LIPID PROFILE ( 7 )",
  "Total Cholesterol / Triglycerides",
  "HDL / LDL / VLDL – Cholesterol",
  "Cholesterol / HDL Cholesterol Ratio",
  "KIDNEY PROFILE (3 )",
  "BUN/BUL/ Uric Acid / Creatinine",
  "Serum Electrolytes (Na+k+Cl-)",
  "SPECIALIZED INVESTIGATIONS",
  "Vitamin B12",
  "Vitamin D3",
  "TFT (Thyroid function Test)T3,T4,TSH",
  "PSA(PROSTATE)",
  "DIAGNOSTIC TESTS",
  "ECG",
  "BMD",
  "X Ray LS Spine AP & LAT",
  "USG Abdomen Pelvis",
  "CT Chest"
        ]
      }
    ]
  }
];
